import React from 'react';
import Templates from '../Templates';
import BlockContainer from './BlockContainer';
import Button from '../Button';

export default function TemplatesBlock({
  title,
  byline,
  category,
  cta_label,
  limit,
  layout,
  bgColor,
  textColor,
  padding,
  showDescriptions,
}) {
  return (
    <BlockContainer
      title={title}
      description={byline}
      bgColor={bgColor}
      textColor={textColor}
      padding={padding}
    >
      <Templates
        slug={category}
        limit={limit || 3}
        textColor={textColor}
        showDescriptions={showDescriptions}
        asSlider={layout === 'slider'}
        hasButton
      />
      <Button
        color={textColor === 'var(--text-light)' ? 'white' : 'midnight'}
        lg
        to={`/templates/category/${category}/`}
      >
        {cta_label}&nbsp;&nbsp;→
      </Button>
    </BlockContainer>
  );
}
